import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import About from "./components/About";
import PropuestaDeValorSection from "./components/PropuestaDeValorSection";
import QuienSoySection from "./components/QuienSoySection";
import Testimonial from "./components/Testimonial";
import Interactive3DSection from "./components/Interactive3DSection";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import SuscripcionSection from "./components/SuscripcionSection";
import VideoSection from "./components/VideoSection";
import MiddleSection from "./components/MiddleSection";
import ContratarSection from "./components/ContratarSection";
import Empresas from "./components/Empresas";
import WhatsAppButton from "./components/WhatsAppButton";
import BlogErnesto from "./BlogErnesto";
import NewScreen from "./NewScreen";
import BlogPostPage from "./components/BlogPost/BlogPostPage";
import FaqIA from "./components/FaqIA";

/* -------------------------------------------------
   EVENTOS
--------------------------------------------------*/
const eventos = {
  online: {
    titulo: "🔥 Taller Revolución IA en SST – Online",
    descripcion:
      "Evento online exclusivo desde plataforma virtual. Accede desde cualquier lugar y aprende con expertos.",
    descripcion2:
      "📅 28 de Marzo de 2026\nEvento 100% online, accede desde donde estés.",
    descripcion3:
      "💡 Vive una experiencia formativa única con IA aplicada a la SST.",
    imagen:
      "https://fotos.esgrymaconsulting.com/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-16-at-8.23.01-AM.jpeg",
    link: "https://revolucion--ia-sst.ernestomora.com/#pricing",
    activo: true
  },

  proximamente: {
    titulo: "🚀 Próximamente",
    descripcion:
      "Estamos preparando una nueva experiencia de alto impacto.",
    descripcion2:
      "IA aplicada a la Seguridad y Salud en el Trabajo.",
    descripcion3:
      "Mantente atento. Lo que viene marcará un antes y un después.",
    activo: false
  }
};

/* -------------------------------------------------
   HOME
--------------------------------------------------*/
const HomePage = () => (
  <div>
    <VideoSection />
    <MiddleSection />
    <About />
    <QuienSoySection />
    <PropuestaDeValorSection />
    <SuscripcionSection />
    <Empresas />
    <Interactive3DSection />
    <Testimonial />
    <ContratarSection />
    <FaqIA />
    <Footer />
    <Copyright />
    <WhatsAppButton />
  </div>
);

/* -------------------------------------------------
   APP
--------------------------------------------------*/
const App = () => {
  const [showModal, setShowModal] = useState(true);
  const [eventoSeleccionado, setEventoSeleccionado] = useState("online");

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">

      {/* RUTAS */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Biografia" element={<NewScreen />} />
        <Route path="/blogernesto" element={<BlogErnesto />} />
        <Route path="/blog/post/:slug" element={<BlogPostPage />} />
      </Routes>

      {/* BOTÓN FLOTANTE */}
      <div className="fixed bottom-4 left-4 z-40">
        <button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-500 p-[3px] rounded-full animate-pulse hover:scale-105 transition-all"
        >
          <div className="bg-black rounded-full px-6 py-3 text-white font-bold text-sm">
            ¡PRÓXIMO EVENTO!
          </div>
        </button>
      </div>

      {/* -------------------------------------------------
         MODAL EVENTO
      --------------------------------------------------*/}
      {showModal && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
          <div className="w-full max-w-2xl max-h-[90vh] bg-black rounded-2xl shadow-2xl overflow-y-auto border border-purple-400">

            <div className="relative text-white">

              {/* CERRAR */}
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-3 right-3 text-3xl font-bold hover:text-red-400"
              >
                ×
              </button>

              {/* SELECTOR */}
              <div className="flex justify-center gap-4 p-4">
                <button
                  onClick={() => setEventoSeleccionado("online")}
                  className={`px-4 py-2 rounded-full font-semibold ${
                    eventoSeleccionado === "online"
                      ? "bg-white text-black"
                      : "border border-white"
                  }`}
                >
                  Online
                </button>

                <button
                  onClick={() => setEventoSeleccionado("proximamente")}
                  className={`px-4 py-2 rounded-full font-semibold ${
                    eventoSeleccionado === "proximamente"
                      ? "bg-white text-black"
                      : "border border-white"
                  }`}
                >
                  Próximamente
                </button>
              </div>

              {/* IMAGEN SOLO ONLINE */}
              {eventos[eventoSeleccionado].activo && (
                <img
                  src={eventos[eventoSeleccionado].imagen}
                  alt="Evento IA SST Online"
                  className="w-full max-h-[420px] object-contain"
                />
              )}

              {/* TEXTO */}
              <div className="px-6 py-6 text-center">
                <p className="text-xl font-bold mb-3">
                  {eventos[eventoSeleccionado].titulo}
                </p>

                <p className="whitespace-pre-line mb-3">
                  {eventos[eventoSeleccionado].descripcion}
                </p>

                <p className="whitespace-pre-line mb-3">
                  {eventos[eventoSeleccionado].descripcion2}
                </p>

                <p className="whitespace-pre-line mb-4">
                  {eventos[eventoSeleccionado].descripcion3}
                </p>

                {/* CTA SOLO ONLINE */}
                {eventos[eventoSeleccionado].activo ? (
                  <a
                    href={eventos[eventoSeleccionado].link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-gradient-to-r from-cyan-300 via-purple-400 to-pink-500 p-[3px] rounded-full"
                  >
                    <div className="bg-black rounded-full px-8 py-3 font-bold text-sm">
                      ¡QUIERO ASISTIR!
                    </div>
                  </a>
                ) : (
                  <p className="text-yellow-400 font-semibold">
                    🔔 Inscripciones próximamente
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
